
export const cryption = {
	version: 1,
	nonceByteCount: 24,
	versionLength: 1,
	tagLength: 16,
}

